module.exports = __webpack_public_path__ + "4360fd99452a2c37d5ff2d322102b32c.svg";